<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong> Ecarts libellés blocage </strong>
      </b-card-header>
      <b-card-body v-if="libellesBlocage">
        <vue-excel-xlsx
          :data="excelData"
          :columns="excelColumns"
          class="export-excel-btn mb-2"
          :filename="'export_ecarts_libelles_blocage_'+getTimestamp()">
          <i class="fa fa-file-excel-o"></i>&nbsp; Exporter en Excel
        </vue-excel-xlsx>
        <table v-if="finished" class="mt-2 w-100" border="1px">
          <thead>
          <tr>
            <td class="prune-medium center p-1"><b>Code blocage</b></td>
            <td class="prune-medium center nowrap p-1"><b>Libellé blocage</b></td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(element, key) in libellesBlocage" :key="key">
            <td class="p-1"> {{ element.code_blocage }}</td>
            <td class="p-1"> {{ element.libelle_blocage }}</td>
          </tr>
          </tbody>
        </table>
      </b-card-body>
      <b-card-body v-else>
        <span>Aucun écart trouvé.</span>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";

  export default {
    name: "EcartsLibellesBlocage",
    data() {
      return {
        libellesBlocage: [],
        finished: false,
        excelColumns: [
          {
            label: "Code blocage",
            field: "code_blocage",
          },
          {
            label: "Libellé blocage",
            field: "libelle_blocage",
          },
        ],
        excelData: [],
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.downloadEcartsLibellesBlocage();
    },
    methods: {
      downloadEcartsLibellesBlocage() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/extractions/ecarts_libelles_blocage')
          .then((response) => {
            this.$store.commit('IS_LOADING', false);
            this.libellesBlocage = response.data.data;
            this.finished = true;
            for (let row of response.data.data) {
              this.excelData.push({
                code_blocage: row.code_blocage,
                libelle_blocage: row.libelle_blocage,
              });
            }
          })
          .catch(error => {
            self.$store.commit('IS_LOADING', false);
            console.log(error);
          });
      },
      getTimestamp() {
        let date = new Date;
        let day = date.getDate().toString().length === 1 ? '0' + date.getDate().toString() : date.getDate().toString();
        let month = (date.getMonth() + 1).toString().length === 1 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let year = date.getFullYear().toString();

        return day + '_' + month + '_' + year;
      },
    }
  }
</script>

<style scoped>

  .prune-medium {
    background-color: #C0504D;
    color: #FFFFFF;
  }

  .center {
    text-align: center;
  }
</style>


